<style lang="scss" scoped>
h4 {
  margin-top: 30px;
  font-weight: normal;
  font-size: 16px;
  color: #666
}
::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: #aaa;
}
::-moz-placeholder { /* Firefox 19+ */
  color: #aaa;
}
:-ms-input-placeholder { /* IE 10+ */
  color: #aaa;
}
:-moz-placeholder { /* Firefox 18- */
  color: #aaa;
}
.btn-box {
  display: inline-block;
  margin-right: 8px;
  /* margin: 0 4px; */
  >.btn {
    border-radius: 0;
    outline: none;

    &:first-child {
      border-radius: 50em 0 0 50em;
    }

    &:last-child {
      border-radius: 0 50em 50em 0;
    }
  }
}

input[type=number] {
  text-align: center;
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
}

.justify-content-end {
  display: flex;
  justify-content: flex-end;
}

.btn {
  background-color: #bbb;
  border: 0;
  color: white;
  transition: background-color .1s;

  &.btn-primary {
    background: linear-gradient(180deg,#EFA057 0%,#8948F1 100%);
  }
}
.btn.-active {
  background-color: #725A7A;
}
.row.-project {
  padding: 10px 0;
  vertical-align: middle;

  &:hover {
    background-color: #f6f6f6;
  }

  &.-active {
    background-color: #fff1d6;
  }
}
.step {
  margin: 60px 0;
}
.-step2 {
  margin-bottom: 32px;
}
.-step2 > h3 {
  margin-top: 24px;
  margin-bottom: 0;
}

.types-panel {
  margin-top: 26px;
  margin-right: 20px;

  >button {
    border-radius: 50em;
    background-color: transparent;
    color: #666;

    &.-active {
      color: #f6f6f6;
    }
  }
}
.row.-header {
  color: #aaa;
  margin-top: 32px;
  margin-bottom: 8px;

  &:after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    position: relative;
    top: 10px;
    background-color: #eee;
  }
  /* text-align: center; */
}
.normal-row-box {
  max-height: 300px;
  overflow-y: scroll;
  overflow-x: hidden;

}
.time-input {
  max-width: 50px;
}

.v-middle-box {
  display: flex;
  justify-content: flex-start;
  align-content: center;
  >i {
    width: 24px;
    font-size: 16px;
    display: inline-flex;
    align-items: center;
  }
  h3 {
    margin-top: 4px;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 0;
  }
}
.content-box {
  margin: 8px 0;

  @media only screen and (min-width: 1200px) {
    margin: 0;
  }
}
.content-box input {
  width: 100%;
}
.time-input, .content-box input {
  height: 38px;
  border-radius: 50em;
}
i.fa {
  cursor: pointer;
}
.search {
  float: right;
  margin-top: 30px;

  .search-input {
    width: 200px;
  }
}
.normal-rows {
  margin-top: 24px;
  border-top: 1px #ddd solid;
}
textarea {
  padding: 12px 16px;
  border-radius: 16px;
  border: 1px solid #eee;
  outline: none;
}

.submit-area {
  display: flex;
  align-items: center;

  position: sticky;
  bottom: 0;
  background-color: #EFEFEF;
  padding: 16px 0;
  border-top: 1px solid #ddd;

  >.hour-display {
    font-size: 18px;
    flex: 1;
    text-align: left;
    color: #666;

    b {
      color: #725A7A;
      font-weight: 600;
    }
  }

  >.btn, a {
    margin-left: 8px;
  }
}
</style>
<template>
  <div>
    <div class="step -step1">
      <h3>{{display_attendance_start_at}} 做了哪些事呢？</h3>
      <div class="star-rows">
        <div class="row">
          <div class="col-lg-3">
            <h4>已釘選專案</h4>
          </div>
        </div>

        <div class="row -header hidden-sm">
          <div class="col-sm-3">
            <span>專案名稱</span>
          </div>
          <div class="col-lg-4 col-md-10">
            <span>今日工作時數</span>
          </div>
          <div class="col-lg-5 col-xs-12">
            <span>今日工作紀錄</span>
          </div>
        </div>
        <div class="row -project" v-for="(project, index) in pinedProjects" v-bind:class="{'-active': project.workDetails.duration != 0}">
          <div class="col-lg-3">
          <span class="v-middle-box">
            <i class="fa fa-star" v-on:click.prevent="unpinProject(project.uuid, user_uuid)" style="color:#ffbe0a"></i>
            <span>
              <div>{{project.client}} ({{(pmList.find(u => u.uuid === project.manager_uuid) || {}).name || project.pm_name || ''}})</div>
              <h3 v-if="project.name" v-html="project.name.replace('（', '<br/>（')"></h3>
            </span>
          </span>
          </div>
          <div class="col-lg-4 col-md-10">
            <div class="btn-box">
              <button v-for="hour in [0.5, 1, 2, 4, 8]" v-bind:class="{'-active': hour === project.workDetails.duration}" class="btn btn-info" type="button" name="button" v-on:click="setDuration(hour, project.uuid)">{{hour}} h</button>
            </div>
            <input type="number" step="0.1" min="0" max="12" class="time-input" v-model="project.workDetails.duration"/>
          </div>
          <div class="col-lg-5 col-xs-12 content-box">
            <input v-bind:tabindex="index + 1" type="text" placeholder="工作記錄（選填）" v-model="project.workDetails.content"/>
          </div>
        </div>
      </div>
      <div class="normal-rows">
        <div class="row">
          <div class="col-lg-12">
            <h4>所有專案</h4>
          </div>
          <div class="col-lg-12" style="text-align:right">
            <div class="types-panel">
              <button v-for="type in types" type="button" class="btn btn-info" v-bind:class="currentTypeFilter === type ? '-active' : ''" v-on:click="setTypeFilter(type)">{{type}}</button>
            </div>
            <div class="search">
              <i class="fa fa-search"></i>
              <input type="text" class="search-input" v-model="search_input" placeholder="專案名稱、PM名、客戶名">
            </div>
          </div>
        </div>
      </div>
      <div class="row -header hidden-sm">
        <div class="col-sm-3">
          <span>專案名稱</span>
        </div>
        <div class="col-lg-4 col-md-10">
          <span>今日工作時數</span>
        </div>
        <div class="col-lg-5 col-xs-12">
          <span>今日工作紀錄</span>
        </div>
      </div>
      <div class="normal-row-box">
        <div class="row -project" v-for="(project, index) in (unpinedProjects)" v-bind:class="{'-active': project.workDetails.duration != 0}">
          <div class="col-lg-3">
          <span class="v-middle-box">
            <i class="fa fa-star-o" v-on:click.prevent="pinProject(project.uuid, user_uuid)"></i>
            <span>
              <div>{{project.client}} ({{(pmList.find(u => u.uuid === project.manager_uuid) || {}).name || project.pm_name || ''}})</div>
              <h3 v-if="project.name" v-html="project.name.replace('（', '<br/>（')"></h3>
            </span>
          </span>
          </div>
          <div class="col-lg-4 col-md-10">
            <div class="btn-box">
              <button v-for="hour in [0.5, 1, 2, 4, 8]" v-bind:class="{'-active': hour === project.workDetails.duration}" class="btn btn-info" type="button" name="button" v-on:click="setDuration(hour, project.uuid)">{{hour}} h</button>
            </div>
            <input type="number" step="0.1" min="0" max="12" class="time-input" v-model="project.workDetails.duration">
          </div>
          <div class="col-lg-5 col-xs-12 content-box">
            <input v-bind:tabindex="index + 1 + pinedProjects.length" type="text" placeholder="工作記錄（選填）" v-model="project.workDetails.content" >
          </div>
        </div>
      </div>
    </div>
    <div class="step -step2">
      <div class="row">
        <div class="col-lg-12 d-flex justify-content-end">
          <a href="#" class="btn btn-sm btn-danger text text-danger" v-on:click.prevent="handleRefreshClick"><i class="fa fa-info-circle"></i> 沒看到你參與的專案嗎？</a>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <h4>專案回顧</h4>
          <textarea v-model="result" rows="10" placeholder="我今天做了......" style="width: 100%;" class="form-control"></textarea>
        </div>
      </div>
      
      <h3>最後確認</h3>
      <div class="row">
        <div class="col-lg-12">
          <h4>本日工作項目小計</h4>
          <p>
            總共工作 {{net_work_hour}} 小時 <br>
            已填 {{work_hour_sum}}
          </p>
          <table class="table .table-responsive">
            <thead style="color:#aaa">
            <tr>
              <td>專案名稱</td>
              <td>登記時數</td>
              <td>工作內容</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="project in workingProjects">
              <td>{{project.client}} - {{project.project_name}}</td>
              <td>{{project.duration}}</td>
              <td>{{project.content}}</td>
            </tr>
            </tbody>
          </table>
          <div v-if="workingProjects.length === 0" class="alert alert-danger" role="alert">
            您尚未選擇今日工作項目呦，請往上滑。
          </div>
        </div>
      </div>
      <hr>
    </div>
    <div class="submit-area text-center" style="margin-top: 30px;">
      <div class="hour-display">已填 <b>{{work_hour_sum}}</b> 小時 / 還剩 <b>{{Math.round((net_work_hour - work_hour_sum) * 100) / 100}}</b> 小時沒填 </div>
      <a href="/attendance" class="btn btn-default btn-lg">返回</a>
      <button class="btn btn-primary btn-lg" v-on:click.prevent="handleSubmit">送出</button>
      </div>
  </div>
</template>

<script>
import _ from 'lodash';
export default {
  props: {
    'attendance_uuid': {
      type: String,
      default: function () {return ''}
    },
    'user_uuid': {
      type: String,
      default: function () {return ''}
    },
    'attendance_start_at': {
      type: String,
      default: function() { return ''}
    },
    'display_attendance_start_at': {
      type: String,
      default: function() { return ''}
    },
  },
  data() {
    return {
      attendance: {},
      projects: {},
      pinedProjectsIDs: [],
      search_input: '',
      result: '',
      currentTypeFilter: '',
      types: [],
      pmList: [],
    }
  },
  computed: {
    pinedProjects() {
      const p = _.filter(this.projects, p => this.pinedProjectsIDs.includes(p.uuid))
      return p;
    },
    unpinedProjects() {
      let projects = _.filter(this.projects, p => !this.pinedProjectsIDs.includes(p.uuid));
      projects = this.typeFilter(projects);
      projects = this.stateFilter(projects);
      projects = this.nameFilter(projects);
      projects = projects.slice(0, 50);
      return projects;
    },
    workingProjects() {
      let projects = JSON.parse(JSON.stringify(this.projects));
      return _.map(_.filter(projects, project => {
        return Number(project.workDetails.duration) > 0
      }), project => {
        return {
          project_uuid: project.uuid,
          project_name: project.name,
          client: project.client,
          duration: project.workDetails.duration,
          content: project.workDetails.content
        }
      })
    },
    work_hour_sum() {
      return this.workingProjects.reduce((sum, project) => {
        return sum + Number(project.duration)
      }, 0);
    },
    net_work_hour() {
      if (!this.attendance) {
        return 0;
      } else {
        return Math.round(100 * secondToHour(this.attendance.net_duration)) / 100;
      }
    },

  },
  mounted() {

    (async () => {
      await this.loadPMList();
      await this.loadProjects();
      await this.loadPinedProjects();
      await this.loadAttendance();
      await this.loadWorkHour();
      await this.loadTypes();
    })()

  },
  methods: {
    handleRefreshClick() {
      sweetAlert({
          title: "更新前請閱讀",
          text: "請先聯絡你的PM，將專案輸入每日一覽表，再按下更新",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "更新!",
          cancelButtonText: "取消",
          closeOnConfirm: false
        },
        () => {
          swal('更新中');
          this.$http.post('/api/project/refresh')
            .then(() => {
              this.refreshProjects()
                .then(() => {
                  swal("已更新!", "再檢查一次專案清單吧", "success");
                })
              ;
            })
          ;
        }
    )
    },
    loadProjects() {
      return this.$http.get('/api/project')
        .then((response) => {
          var projects = {};
          
          var data = response.data;

          if (typeof(data) === 'string') {
            data = JSON.parse(data);
          }
          
          for (var i = 0; i < data.length; i ++) {
            projects[data[i].uuid] = Object.assign({}, data[i], {
              workDetails: {
                duration: 0,
                content: ''
              }
            });
          }
          this.projects = projects;
        });
    },
    loadPMList() {
        return this.$http.get('/api/project/pm_list')
            .then(response => {
                this.pmList = response.data;
            });
    },
    refreshProjects() {
      return this.$http.get('/api/project')
        .then((response) => {
          var projects = JSON.parse(JSON.stringify(this.projects));
          
          if (typeof(response.data) === 'string') {
            response.data = JSON.parse(response.data);
          }
          
          for (var i = 0; i < response.data.length; i ++) {
            if (projects[response.data[i].uuid]) {
              projects[response.data[i].uuid] = Object.assign({}, projects[response.data[i].uuid], response.data[i]);
            } else {
              projects[response.data[i].uuid] = Object.assign({}, response.data[i], {
                workDetails: {
                  duration: 0,
                  content: ''
                }
              });
            }
          }
          this.projects = projects;
        });
    },
    loadPinedProjects() {
      return this.$http.get('/api/project/user/' + this.user_uuid + '/pin')
        .then(response => {
          var data = response.data;
          
          if (typeof(data) === 'string') {
            data = JSON.parse(data);
          }
          
          this.pinedProjectsIDs = data.map(data => {
            return data.uuid;
          });
        });
    },
    loadAttendance() {
      return this.$http.get('/api/attendance/' + this.attendance_uuid)
        .then(response => {
          var data = response.data;
          
          if (typeof(data) === 'string') {
            data = JSON.parse(data);
          }
          
          this.attendance = data;
          this.result = data.content;
        });
    },
    loadTypes() {
      return this.$http.get('/api/project/types')
        .then(response => {
          var data = response.data;
          
          if (typeof(data) === 'string') {
            data = JSON.parse(data);
          }
          
          this.types = data;
        });
    },
    loadWorkHour() {
      return this.$http.get('/api/attendance/' + this.attendance_uuid + '/work_hour')
        .then(response => {
          if (typeof(response.data) === 'string') {
            response.data = JSON.parse(response.data);
          }

          if (Array.isArray(response.data)) {
            response.data.forEach(((item) => {
              var project_uuid = item.project_uuid;

              if (this.projects[project_uuid]) {
                this.projects[project_uuid].workDetails = {
                  content: item.content,
                  duration: parseFloat(parseInt(item.duration) / 3600),
                }
              }
            }).bind(this));
          }
        });
    },
    setDuration(duration, project_uuid) {
      if (duration ===  this.projects[project_uuid].workDetails.duration) {
        this.projects[project_uuid].workDetails.duration = 0;
      }
      else {
        this.projects[project_uuid].workDetails.duration = duration;
      }
    },
    pinProject(project_uuid, user_uuid) {
      this.pinedProjectsIDs.push(project_uuid);
      this.updatePin(project_uuid, user_uuid, true);
    },
    unpinProject(project_uuid, user_uuid) {
      var i = this.pinedProjectsIDs.indexOf(project_uuid);
      if (i > -1) {
        this.pinedProjectsIDs.splice(i, 1);
      }
      this.updatePin(project_uuid, user_uuid, false);
    },
    updatePin(project_uuid, user_uuid, toPin) {
      this.$http.post('/api/project/pin', {
        project_uuid,
        user_uuid,
        pin: toPin,
      });
    },
    handleSubmit() {
      this.$http.post('/api/attendance/' + this.attendance_uuid + '/work_hour', {
        result: this.result,
        work_hour: this.workingProjects.map(project=> {
          var p = JSON.parse(JSON.stringify(project));
          p.duration = hourToSecond(project.duration);
          return p
        })
      }).then(response => {
          if (response.status > 299) {
            sweetAlert({title: '更新失敗QQ，找一下工程師喔', type: 'error'})
          } else {
            sweetAlert({title: '提交成功', text: '辛苦啦！',confirmButtonText: '離開這頁',  showCancelButton: true, cancelButtonText: '繼續修改', type: 'success'}, () => {
              window.location.href = '/attendance';
            })
          }
        }, response => {
          if (response.status > 299) {
            sweetAlert({title: '更新失敗QQ，找一下工程師喔', type: 'error', confirmButtonText: 'QQ'})
          } else {
            sweetAlert({title: '提交成功', text: '辛苦啦！',confirmButtonText: '離開這頁',  showCancelButton: true, cancelButtonText: '繼續修改', type: 'success'}, () => {
              window.location.href = '/attendance';
            })
          }
        });
    },
    countScaledDuration(projectDuration) {
      // var start_at = Date.parse(this.attendance.end_at) || Date.now();
      var totalWorkHours = this.attendance.net_duration / 3600;
      return Math.round((projectDuration / this.work_hour_sum) * totalWorkHours * 100) / 100 //四捨五入到小數第二位
    },
    setTypeFilter(type) {
      this.currentTypeFilter = type;
    },
    stateFilter(items) {
      var regex = new RegExp('(已結案|提案失敗)');
      return items.filter((item) => {
        return !regex.test(item.status);
      });
    },
    nameFilter(items) {
      const search = this.search_input;
      if (!search || search.length === 0) {
        return items;
      }

      var regex = new RegExp(search, 'i');

      return items.filter((item) => {
        return regex.test(item.name) || regex.test(item.pm_name) || regex.test(item.client);
      });
    },
    typeFilter(items) {
      if (!this.currentTypeFilter || this.currentTypeFilter.length === 0) {
        return items;
      }

      return items.filter((item) => {
        return item.type === this.currentTypeFilter
      })
    }
  },
}

const hourToSecond = hr => {
  return hr * 3600
}

const secondToHour = sec => {
  return sec / 3600
}
</script>
